
define('template!sdcGetController',[''],function(template){return '<!DOCTYPE html>\r\n<html xmlns="http://www.w3.org/1999/xhtml">\r\n<head>\r\n    <title></title>\r\n</head>\r\n<body>\r\n\r\n</body>\r\n</html>\r\n';});

